module.exports = __webpack_public_path__ + "img/ifmsys.4e060519.svg";